"use client";

import { CustomGrid } from "@/components/layout/grid";
import { ClientEnvironmentContext } from "@/utils/globalConfig";
import { GridItem, Heading } from "@chakra-ui/react";
import DOMPurify from "isomorphic-dompurify";
import { useContext } from "react";

export default function CookieDeclaration({
  title,
  ...props
}: {
  title: string;
}) {
  const clientEnvironment = useContext(ClientEnvironmentContext);
  return (
    <CustomGrid>
      <GridItem colSpan={6} colStart={4}>
        <Heading
          as={"h1"}
          fontSize={{ base: "2rem", lg: "5.5rem" }}
          lineHeight={1}
          fontWeight={400}
          color={"brand.aubergine"}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(title.replace(/<\/p>/g, "</br>"), {
              ALLOWED_TAGS: ["strong", "br"],
            }),
          }}
          sx={{
            strong: {
              fontWeight: 400,
              color: "brand.cyan",
              fontFamily: "Lausanne, sans-serif",
            },
          }}
        />
      </GridItem>
      <GridItem
        colSpan={6}
        colStart={4}
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: `<script async type="text/javascript" src="https://consent.cookiebot.com/${clientEnvironment?.cookieBotDomainGroupId}/cd.js" ></script>`,
        }}
        sx={{
          div: {
            div: {
              display: "none",
            },
          },
        }}
      >
        {/* <Script
            strategy='afterInteractive'
            id='CookieDeclaration'
            src={`https://consent.cookiebot.com/${cookieDomainID}/cd.js`}
            type='text/javascript'
            async
          /> */}
      </GridItem>
    </CustomGrid>
  );
}
